import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DecisionNode, DecisionNodeListData, DecisionNodesState } from '../../types/decisionNodes.types';

const initialState: DecisionNodesState = {
  nodes: [],
  selectedNode: null,
  loading: false,
  error: null,
  pagination: {
    page: 1,
    pageSize: 10,
    totalPages: 0,
    totalRecords: 0,
    hasMorePages: false,
  },
  search: '',
  sort: {
    field: 'displayOrder',
    order: 'asc',
  },
};

const decisionNodesSlice = createSlice({
  name: 'decisionNodes',
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string | null>) {
      state.error = action.payload;
    },
    setNodes(state, action: PayloadAction<DecisionNodeListData>) {
      state.nodes = action.payload.nodes;
      state.pagination.totalPages = action.payload.totalPages;
      state.pagination.totalRecords = action.payload.totalRecords;
      state.pagination.hasMorePages = action.payload.hasMorePages;
    },
    setSelectedNode(state, action: PayloadAction<DecisionNode | null>) {
      state.selectedNode = action.payload;
    },
    clearSelectedNode(state) {
      state.selectedNode = null;
    },
    setPage(state, action: PayloadAction<number>) {
      state.pagination.page = action.payload;
    },
    setPageSize(state, action: PayloadAction<number>) {
      state.pagination.pageSize = action.payload;
      state.pagination.page = 1;
    },
    setSearch(state, action: PayloadAction<string>) {
      state.search = action.payload;
      state.pagination.page = 1;
    },
    setSort(state, action: PayloadAction<{ field: string; order: string }>) {
      state.sort = action.payload;
      state.pagination.page = 1;
    },
    addNode(state, action: PayloadAction<DecisionNode>) {
      state.nodes.unshift(action.payload);
      state.pagination.totalRecords += 1;
    },
    updateNode(state, action: PayloadAction<DecisionNode>) {
      const index = state.nodes.findIndex((n) => n.id === action.payload.id);
      if (index !== -1) {
        state.nodes[index] = action.payload;
      }
    },
    removeNode(state, action: PayloadAction<string>) {
      state.nodes = state.nodes.filter((n) => n.id !== action.payload);
      state.pagination.totalRecords -= 1;
    },
    resetState() {
      return initialState;
    },
  },
});

export const {
  setLoading,
  setError,
  setNodes,
  setSelectedNode,
  clearSelectedNode,
  setPage,
  setPageSize,
  setSearch,
  setSort,
  addNode,
  updateNode,
  removeNode,
  resetState,
} = decisionNodesSlice.actions;

export default decisionNodesSlice.reducer;
